export default "__VITE_ASSET__DYgUVmJH__"